import React from "react";
import "./Home.css";
import profile from "../../Images/NAAZ_pic1.jpg";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import resume from "../../Images/Najrin-Shah-Resume.pdf";
import wave from "../../Images/wave.gif";
import { useEffect } from "react";
import { init } from 'ityped'
import { useRef } from "react";
import { DownloadIcon } from "@chakra-ui/icons";
const Home = () => {
  const textRef=useRef();
  const toggleClick2 = () => {
    window.open(
      "https://drive.google.com/file/d/1-ySbYAzy2x-HRJgWV-thioGRaLwAh1lK/view?usp=share_link"
    );
  };

   useEffect(() => {
      init(textRef.current,{
        showCursor:false,
        strings:["Full Stack Developer !","MERN Developer !"]
      })
   }, []);
  return (
    <>
      <Box bgColor="#1A202C" color="white" id="home" p="8vh 0" >
        <Flex
          p="80px"
          flexDirection={["column", "column", "row", "row"]}
          // flexWrap="wrap"
          justifyContent={["space-between"]}
          alignItems="center"
        >
          <Box ml={2} textAlign="left">
            <Flex fontSize={["xl", "3xl", "4xl"]} fontWeight="bold" alignItems="center">
              <Text>Hey</Text>
              <Image src={wave} w="10%" />
              <Text>!!! I am Najrin</Text>
            </Flex>
            <Text
              fontSize={["md", "xl", "3xl", "5xl"]}
              fontWeight="bold"
              h={["10vh", "8vh", "20vh"]}
            >
              A <span ref={textRef} style={{ color: "teal" }}></span>
            </Text>
            <a target="_blank" href={resume} download="Najrin-Shah-Resume.pdf">
              <Button
                color="white"
                m={["30px 0px", "20px 0px", "10px 0px"]}
                size={["xs", "sm", "md", "lg"]}
                className="resume"
                bg="#1A202C"
                border="1px solid white"
                onClick={toggleClick2}
              >
                Resume&nbsp;
                <DownloadIcon />
              </Button>
            </a>
          </Box>
          <Box>
            <Image src={profile} borderRadius="full" alt="Dan Abramov" />
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default Home;
